import React, { useState, useEffect, useCallback } from "react";
import './questionnaires-administration-configurations-view.css'
import { profileIconDefault } from "../../../assets/logos/icons";
import { QuestionnaireService } from "../../../services"
import QuestionnairesAdministrationDuplicateQuestionnaireView from "./questionnaires-administration-duplicate-questionnaire-view";
import QuestionnairesAdministrationEditQuestionView from "./questionnaires-administration-edit-question.view";
import QuestionnairesAdministrationEditDetailView from "./questionnaires-administration-edit-questionnaire.view";
import QuestionnairesAdministrationManageQuestionsView from "./questionnaires-administration-manage-questions.view";
import QuestionnairesAdministrationNewQuestionnaireView from "./questionnaires-administration.new.questionnaire.view";
import { useTranslation } from "react-i18next";
import { NIL as NIL_UUID } from 'uuid';
import QuestionnairesAdministrationDisableView from "./questionnaires-administration-disable.view";
import QuestionnnairesAssignCategories from "./questionnaires-assign-categories";


const QuestionnairesAdministrationConfigurationsView = ({
  selectedQuestionnaire,
  hideShowDetails,
  nameComponentUser,
  token,
  setHeaderTitleinDetail,
  companySelected,
  user,
  setNameComponentUser,
  setShowDetails,
  setImagetitle,
  imageTitle,
  companysForUser,
  allInfoQuestionToSend,
  setAllInfoQuestionToSend,
  setAllInfoQuestionToSendStirng,
  allInfoQuestionToSendStirng,
  forceRefresh,
  toggleErrorRequesting,
  toggleLoadingRequesting,
  toggleCompletedRequesting,
  showCompletedRequesting,
  showErrorRequesting,
  showLoadingRequesting,
  setStateNameComponentUser,
  stateNameComponentUser,
  setFlagToCleanDataQuestion,
  flagToCleanDataQuestion,
  setTemplates,
  templates,
  errorInfoQuestions,
  toggleCompletedQuestionsRequesting,
  setErrorinfoQuestions,
  getContractPersonTypes,
  personTypes,
  standardContract,
  changeRedirect,
  getUserCompanies,
  userCompanies,
  getUserCategories,
  categories,
  getUserSubcategires,
  subCategories,
  getTypeDocuments,
  typeDocuments,
  handleAssignCategories,
  setDigitalVaultCategory,
  onExpandTree,
  changeRoute,
  icons,
  createSubcategory,
  refreshCategories,
  permission
}) => {

  const { t } = useTranslation();

  const [showDetailComponent, setShowComponentDetail] = useState(false);
  const [showCompletedRequest, setShowCompletedRequest] = useState(false);
  const [showLoadingRequest, setShowLoadingRequest] = useState(false);
  const [selectedQuestion, setselectedQuestions] = useState({});
  const [templateSelected, setTemplateSelected] = useState({})
  const [variablesForQuestionnaire, setVariablesForQuestionnaire] = useState([])
  const [variablesToShow, setVariablesToShow] = useState([])
  const [currencyUnits, setCurrencyunits] = useState([])
  const [copyComplteTemplates, setCopyCompleteTemplates] = useState([])
  const [questionsBeforeSend, setQuestionsBeforeSend] = useState([])
  const [idTemplateDuplicate, setIdTemplateDuplicate] = useState(
    {
      active: true,
      clientId: 0,
      companyId: NIL_UUID,
      createdDate: "",
      deactivationReason: null,
      description: "",
      documentLoaded: null,
      documentPath: null,
      id: NIL_UUID,
      name: "Sin template",
      templateVariable: [],
      updatedDate: "",
      variableCount: null
    }
  );

  const iconEditQuestionnaire = selectedQuestionnaire && selectedQuestionnaire.logo !== '' ? selectedQuestionnaire.logo : profileIconDefault

  let templatesToDrop = [{
    active: true,
    clientId: 0,
    companyId: NIL_UUID,
    createdDate: "",
    deactivationReason: null,
    description: "",
    documentLoaded: null,
    documentPath: null,
    id: NIL_UUID,
    name: "Sin template",
    templateVariable: [],
    updatedDate: "",
    variableCount: null
  }
  ]

  const toggleShowDetailComponent = () => {
    setShowComponentDetail(false);
    setStateNameComponentUser("Ver-detalle");
  };

  const toggleCompleteRequest = () => {
    setShowCompletedRequest(true);

    setTimeout(() => {
      setShowCompletedRequest(false);
      hideShowDetails();
    }, 4000);
  };




  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  useEffect(() => {
    setStateNameComponentUser(nameComponentUser);
    setImagetitle(iconEditQuestionnaire)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nameComponentUser]);

  useEffect(() => {
    renderComponentQuestionnaire();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateNameComponentUser]);


  //get all currency units
  const getAllCurrencyUnits = async () => {
    let questionnaireService = new QuestionnaireService(process.env.REACT_APP_MIFIRMA_API);
    let currencyUnits = await questionnaireService.getAllCurrencyUnits(token)
    if (currencyUnits.status === 200) {
      setCurrencyunits(currencyUnits.data.data)
    }
  }

  useEffect(() => {
    getAllCurrencyUnits()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedQuestionnaire])

  const cancelModalDeleteQuestion = () => {
    setNameComponentUser(t("questionnairesAdministrationView.btn.adm.questions.grid"));
    setShowDetails(true);
  }

  const handleBackView = (view) => {
    setNameComponentUser(view);
    setShowDetails(true);
  }


  const renderComponentQuestionnaire = useCallback(() => {
    switch (stateNameComponentUser) {
      case t("questionnairesAdministrationView.btn.adm.questions.grid"):
        return (
          <QuestionnairesAdministrationManageQuestionsView
            selectedQuestionnaire={selectedQuestionnaire}
            companySelected={companySelected}
            hideShowDetails={hideShowDetails}
            toggleShowDetailComponent={toggleShowDetailComponent}
            showDetailComponent={showDetailComponent}
            user={user}
            token={token}
            setShowDetails={setShowDetails}
            setNameComponentUser={setNameComponentUser}
            setselectedQuestions={setselectedQuestions}
            setVariablesForQuestionnaire={setVariablesForQuestionnaire}
            setVariablesToShow={setVariablesToShow}
            setAllInfoQuestionToSend={setAllInfoQuestionToSend}
            allInfoQuestionToSend={allInfoQuestionToSend}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showLoadingRequesting={showLoadingRequesting}
            allInfoQuestionToSendStirng={allInfoQuestionToSendStirng}
            setAllInfoQuestionToSendStirng={setAllInfoQuestionToSendStirng}
            errorInfoQuestions={errorInfoQuestions}
            nameComponentUser={nameComponentUser}
            questionsBeforeSend={questionsBeforeSend}
            setQuestionsBeforeSend={setQuestionsBeforeSend}
          />
        );
      case t("questionnairesAdministrationView.grid.detail"):
        return (
          <QuestionnairesAdministrationEditDetailView
            selectedQuestionnaire={selectedQuestionnaire}
            companySelected={companySelected}
            user={user}
            token={token}
            hideShowDetails={hideShowDetails}
            toggleCompleteRequest={toggleCompleteRequest}
            toggleShowDetailComponent={toggleShowDetailComponent}
            showCompletedRequest={showCompletedRequest}
            setShowComponentDetail={setShowComponentDetail}
            setStateNameComponentUser={setStateNameComponentUser}
            setHeaderTitleinDetail={setHeaderTitleinDetail}
            setNameComponentUser={setNameComponentUser}
            setShowDetails={setShowDetails}
            imageTitle={imageTitle}
            setTemplateSelected={setTemplateSelected}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showLoadingRequesting={showLoadingRequesting}
            templates={templates}
            setTemplates={setTemplates}
            nameComponentUser={nameComponentUser}
            setIdTemplateDuplicate={setIdTemplateDuplicate}
            icons={icons}
          />
        );

      case t("questionnairesAdministrationEditDetailView.btn.add.questionnaire"):
        return (
          <QuestionnairesAdministrationNewQuestionnaireView
            changeRedirect={changeRedirect}
            companySelected={companySelected}
            standardContract={standardContract}
            user={user}
            token={token}
            hideShowDetails={hideShowDetails}
            toggleCompleteRequest={toggleCompleteRequest}
            toggleShowDetailComponent={toggleShowDetailComponent}
            showCompletedRequest={showCompletedRequest}
            setShowComponentDetail={setShowComponentDetail}
            setStateNameComponentUser={setStateNameComponentUser}
            setHeaderTitleinDetail={setHeaderTitleinDetail}
            imageTitle={imageTitle}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showLoadingRequesting={showLoadingRequesting}
            templates={templates}
            setTemplates={setTemplates}
            changeRoute={changeRoute}
            icons={icons}
          />
        );
      case t("questionnairesAdministrationEditDetailView.btn.duplicate.questionnaire"):
        return (
          <QuestionnairesAdministrationDuplicateQuestionnaireView
            selectedQuestionnaire={selectedQuestionnaire}
            companySelected={companySelected}
            user={user}
            token={token}
            hideShowDetails={hideShowDetails}
            toggleCompleteRequest={toggleCompleteRequest}
            toggleShowDetailComponent={toggleShowDetailComponent}
            showCompletedRequest={showCompletedRequest}
            setShowComponentDetail={setShowComponentDetail}
            setStateNameComponentUser={setStateNameComponentUser}
            setHeaderTitleinDetail={setHeaderTitleinDetail}
            imageTitle={imageTitle}
            companysForUser={companysForUser}
            templateSelected={templateSelected}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showLoadingRequesting={showLoadingRequesting}
            templates={templates}
            idTemplateDuplicate={idTemplateDuplicate}
            nameComponentUser={nameComponentUser}
          />
        )
      case t("questionnairesAdministrationEditDetailView.btn.edit.question"):
        return (
          <QuestionnairesAdministrationEditQuestionView
            getContractPersonTypes={getContractPersonTypes}
            user={user}
            token={token}
            selectedQuestionnaire={selectedQuestionnaire}
            selectedQuestion={selectedQuestion}
            hideShowDetails={hideShowDetails}
            toggleShowDetailComponent={toggleShowDetailComponent}
            showDetailComponent={showDetailComponent}
            toggleCompleteRequest={toggleCompleteRequest}
            setStateNameComponentUser={setStateNameComponentUser}
            setShowDetails={setShowDetails}
            variablesForQuestionnaire={variablesForQuestionnaire}
            currencyUnits={currencyUnits}
            variablesToShow={variablesToShow}
            setAllInfoQuestionToSend={setAllInfoQuestionToSend}
            allInfoQuestionToSend={allInfoQuestionToSend}
            nameComponentUser={nameComponentUser}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showLoadingRequesting={showLoadingRequesting}
            setAllInfoQuestionToSendStirng={setAllInfoQuestionToSendStirng}
            flagToCleanDataQuestion={flagToCleanDataQuestion}
            setFlagToCleanDataQuestion={setFlagToCleanDataQuestion}
            setNameComponentUser={setNameComponentUser}
            errorInfoQuestions={errorInfoQuestions}
            toggleCompletedQuestionsRequesting={toggleCompletedQuestionsRequesting}
            personTypes={personTypes}


          />
        )
      case t("questionnairesAdministrationView.header.title.add.question"):
        return (
          <QuestionnairesAdministrationEditQuestionView
            getContractPersonTypes={getContractPersonTypes}
            user={user}
            token={token}
            selectedQuestion={selectedQuestion}
            selectedQuestionnaire={selectedQuestionnaire}
            hideShowDetails={hideShowDetails}
            toggleShowDetailComponent={toggleShowDetailComponent}
            showDetailComponent={showDetailComponent}
            toggleCompleteRequest={toggleCompleteRequest}
            setStateNameComponentUser={setStateNameComponentUser}
            setShowDetails={setShowDetails}
            variablesForQuestionnaire={variablesForQuestionnaire}
            currencyUnits={currencyUnits}
            variablesToShow={variablesToShow}
            setAllInfoQuestionToSend={setAllInfoQuestionToSend}
            allInfoQuestionToSend={allInfoQuestionToSend}
            nameComponentUser={nameComponentUser}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            showLoadingRequesting={showLoadingRequesting}
            setAllInfoQuestionToSendStirng={setAllInfoQuestionToSendStirng}
            flagToCleanDataQuestion={flagToCleanDataQuestion}
            setFlagToCleanDataQuestion={setFlagToCleanDataQuestion}
            setNameComponentUser={setNameComponentUser}
            errorInfoQuestions={errorInfoQuestions}
            toggleCompletedQuestionsRequesting={toggleCompletedQuestionsRequesting}
            personTypes={personTypes}

          />
        )
      case t("questionnairesAdministrationView.grid.disable"):
        return (
          <QuestionnairesAdministrationDisableView
            user={user}
            token={token}
            selectedQuestion={selectedQuestion}
            selectedQuestionnaire={selectedQuestionnaire}
            hideShowDetails={hideShowDetails}
            toggleShowDetailComponent={toggleShowDetailComponent}
            showDetailComponent={showDetailComponent}
            toggleCompleteRequest={toggleCompleteRequest}
            setStateNameComponentUser={setStateNameComponentUser}
            setShowDetails={setShowDetails}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            setNameComponentUser={setNameComponentUser}

          />
        )

      case t("questionnairesAdministrationView.grid.assign.categories"):
        return (
          <QuestionnnairesAssignCategories
            getUserCompanies={getUserCompanies}
            userCompanies={userCompanies}
            getUserCategories={getUserCategories}
            categories={categories}
            getUserSubcategires={getUserSubcategires}
            subCategories={subCategories}
            getTypeDocuments={getTypeDocuments}
            typeDocuments={typeDocuments}
            handleBackView={handleBackView}
            handleAssignCategories={handleAssignCategories}
            companySelected={companySelected}
            selectedQuestionnaire={selectedQuestionnaire}
            hideShowDetails={hideShowDetails}
            setDigitalVaultCategory={setDigitalVaultCategory}
            onExpandTree={onExpandTree}
            createSubcategory={createSubcategory}
            refreshCategories={refreshCategories}
            permission={permission}
          />
        )
      default:
        return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    stateNameComponentUser,
    selectedQuestionnaire,
    hideShowDetails,
    setHeaderTitleinDetail,
    token,
    showDetailComponent,
    showCompletedRequest,
  ]);

  return <>{renderComponentQuestionnaire()}</>;
};

export default QuestionnairesAdministrationConfigurationsView;
